module.exports = __webpack_public_path__ + "media/images/icons/twotone/switcher-87e22fa997cb52ec5a9cf560768a3bc0.svg";